export default "/images/vendor/@coreui/icons/svg/flag/cif-hu.svg?8f397b1f3afdc7b8412cfc502b986470";